export default __webpack_public_path__ + "static/media/our-approach.eff2d2de.png";